import React, { Component } from 'react'
import { Link } from 'react-router-dom';
export default class Terms extends Component {
    render() {
        return (
            <div>
                <nav id="nav-wrap">
                    <a className="mobile-btn" href="#nav-wrap" title="Show navigation">
                        Show navigation
                    </a>
                    <a className="mobile-btn" href="#home" title="Hide navigation">
                        Hide navigation
                    </a>

                    <ul id="nav" className="nav">
                        <li className="current">
                            <Link to="/">Home</Link>

                        </li>
                        <li>
                            <Link to="/">                About
                            </Link>
                        </li>

                        <li>
                            <Link to="/">                Contact
                            </Link>
                        </li>
                       
                        <li>
              <Link to="/terms-and-conditions">Terms and conditions</Link>

            </li>
            <li>
              <Link to="/privacy-policy">PrivacyPolicy</Link>

            </li>
            <li>
              <Link to="/return-policy">Return and refund</Link>
            </li>

                    </ul>
                </nav>
                <section id="resume">
                    <div className="row education">
                        <h2>Terms and Conditions</h2>

                        <ol>
                            <li>
                                <h3>Acceptance of Terms</h3>
                                <p>
                                    By accessing and using this website (https://yogesh-sharma.netlify.app/), you agree to comply with and be bound by these terms and conditions. If you disagree with any part of these terms, please refrain from using our website.
                                </p>
                            </li>

                            <li>
                                <h3>Intellectual Property Rights</h3>
                                <p>
                                    All content, including but not limited to text, graphics, logos,
                                    images, audio clips, and software on this website, is the property
                                    of Yogesh Sharma unless otherwise stated. You may not reproduce,
                                    distribute, or use any content from this website without explicit
                                    permission.
                                </p>
                            </li>
                            <li>
                                <h3>User Conduct</h3>
                                <p>
                                    When using this website, you agree not to engage in any activity that could interfere with or disrupt the functionality or security of the site. This includes, but is not limited to, attempting to gain unauthorized access to any part of the website or using the site for any unlawful purpose.
                                </p>
                            </li>
                            <li>
                                <h3>Limitation of Liability</h3>
                                <p>
                                    Yogesh Sharma shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising out of your access to or use of this website. We strive to provide accurate and up-to-date information, but we make no warranties or representations regarding the accuracy or completeness of the content.
                                </p>
                            </li>
                            <li>
                                <h3>External Links</h3>
                                <p>
                                    This website may contain links to third-party websites for additional information or resources. These links are provided solely for convenience and do not signify endorsement. We are not responsible for the content or reliability of any linked websites.
                                </p>
                            </li>
                            <li>
                                <h3>Changes to Terms and Conditions</h3>
                                <p>
                                    Yogesh Sharma reserves the right to modify or replace these terms and conditions at any time without prior notice. Your continued use of the website after any changes will constitute acceptance of such changes.
                                </p>
                            </li>
                            <li>
                                <h3>Contact Information</h3>
                                <p>
                                    If you have any questions or concerns regarding these terms and conditions, please contact us at theyogeshsharma06@gmail.com.
                                </p>
                            </li>
                        </ol>
                    </div>
                </section>
            </div>
        )
    }
}
